export const ALL_TICKETS_REQUEST = "ALL_TICKETS_REQUEST";
export const ALL_TICKETS_SUCCESS = "ALL_TICKETS_SUCCESS";
export const ALL_TICKETS_FAIL = "ALL_TICKETS_FAIL";
